/**
 * @generated SignedSource<<96b15ac1d5de83f2bdf61ce7fe80ca6e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmailTemplateDetailsView_emailTemplate$data = {
  readonly emailLayout: {
    readonly emailLayoutIdentifier: string;
    readonly id: string;
    readonly name: string;
    readonly textContent: string;
  } | null | undefined;
  readonly emailTemplateIdentifier: string;
  readonly id: string;
  readonly images: ReadonlyArray<{
    readonly emailTemplateImageIdentifier: string;
    readonly fileSize: number;
    readonly height: number;
    readonly id: string;
    readonly mediaType: string;
    readonly originalFilename: string;
    readonly url: string;
    readonly width: number;
  }>;
  readonly primaryLanguage: string;
  readonly usageCount: number;
  readonly variants: ReadonlyArray<{
    readonly htmlContent: string | null | undefined;
    readonly language: string;
    readonly preheader: string | null | undefined;
    readonly subject: string | null | undefined;
    readonly textContent: string | null | undefined;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteEmailTemplateDialog_emailTemplate">;
  readonly " $fragmentType": "EmailTemplateDetailsView_emailTemplate";
};
export type EmailTemplateDetailsView_emailTemplate$key = {
  readonly " $data"?: EmailTemplateDetailsView_emailTemplate$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmailTemplateDetailsView_emailTemplate">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textContent",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmailTemplateDetailsView_emailTemplate",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailTemplateIdentifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryLanguage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmailTemplateVariant",
      "kind": "LinkedField",
      "name": "variants",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "language",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subject",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "preheader",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "htmlContent",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmailLayout",
      "kind": "LinkedField",
      "name": "emailLayout",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailLayoutIdentifier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmailTemplateImage",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailTemplateImageIdentifier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "originalFilename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "width",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "height",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mediaType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fileSize",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "usageCount",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeleteEmailTemplateDialog_emailTemplate"
    }
  ],
  "type": "EmailTemplate",
  "abstractKey": null
};
})();

(node as any).hash = "918d420d1abb47323efb2977cc249fb2";

export default node;
